<script lang="ts">
  import type { ColorScheme, IconName } from '$lib/types/components';
  import { twMerge } from 'tailwind-merge';
  import Button from './Button.svelte';
  import Icon from './Icon.svelte';

  export let name: IconName;
  export let ariaLabel: string;
  export let size: 'md' | 'lg' = 'md';
  export let href: string | undefined = undefined;
  export let scheme: ColorScheme = 'light';
  export let circleOnHover: boolean = false;
  export let iconClass: string = '';
  export let disabled: boolean = false;

  const { class: restPropsClass, ...restProps } = $$restProps;
</script>

<Button
  variant="naked"
  {href}
  aria-label={ariaLabel}
  class={twMerge(
    'inline-flex items-center justify-center rounded-full transition-[color,_background-color,_border-color,_opacity] duration-300 hover:bg-blue',
    scheme === 'light' && 'bg-blue-950 text-white disabled:bg-blue-950',
    scheme === 'dark' && 'bg-blue-200 text-blue-950 hover:text-white',
    size === 'md' && 'h-10 w-10',
    size === 'lg' && 'h-12 w-12',
    circleOnHover && 'bg-transparent',
    circleOnHover &&
      scheme === 'light' &&
      'text-blue-950 hover:bg-blue-200 disabled:hover:bg-inherit',
    circleOnHover && scheme === 'dark' && 'text-white hover:bg-gray-700',
    restPropsClass
  )}
  {disabled}
  {...restProps}
  on:click
  on:change
  on:keydown
  on:keyup
  on:touchend
  on:touchcancel
  on:mouseenter
  on:mouseleave
>
  <Icon {name} class={iconClass} />
</Button>

<!--
@component
Circular button with an icon inside.
## Props
@prop name: IconName;
@prop size: 'md' | 'lg' = 'md';
@prop href: string | undefined = undefined;
@prop scheme: ColorScheme = 'light';
@prop circleOnHover: boolean = false;
-->
